import { useState } from "react";

// MUI
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import DoneOutlineIcon from "@mui/icons-material/DoneOutlined";

import Paper from "@mui/material/Paper";
import InputBase from "@mui/material/InputBase";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import ClearIcon from "@mui/icons-material/Clear";

export const OrderSummaryEditQty = ({ item, handleUpdateItemQty }) => {
  const [editMode, setEditMode] = useState(false);
  const [newQty, setNewQty] = useState(Number(item.quantity));
  const handleEditClick = () => setEditMode(true);

  const handleUpdateClick = () => {
    handleUpdateItemQty(item, newQty);
    setEditMode(false);
  };

  const handleCancelClick = () => {
    setEditMode(false);
  };

  const incrementQuantity = () => setNewQty(newQty + 1);
  const decrementQuantity = () => setNewQty(newQty - 1);

  const QuantityInput = () => {
    return (
      <Stack direction="row" spacing={1}>
        <Paper
          elevation={0}
          sx={{
            p: "2px 4px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: 120,
            border: 1,
            borderColor: "info.main",
          }}
        >
          <IconButton
            aria-label="Minus Quantity"
            color="info"
            size="small"
            onClick={decrementQuantity}
            disabled={newQty === 0}
          >
            <RemoveIcon />
          </IconButton>
          <InputBase
            sx={{
              "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
                {
                  display: "none",
                },
              "& input[type=number]": {
                MozAppearance: "textfield",
              },
            }}
            value={newQty}
            // disabled={!validSKU()}
            type="number"
            size="small"
            slotProps={{
              htmlInput: {
                min: 0,
                // max: entitlementLock && item.entitlement,
                style: { textAlign: "center" },
              },
            }}
          />
          <IconButton
            aria-label="Add Quantity"
            color="info"
            size="small"
            onClick={incrementQuantity}
            // disabled={!validSKU()}
          >
            <AddIcon />
          </IconButton>
        </Paper>
      </Stack>
    );
  };

  return (
    <>
      {!editMode ? (
        <Stack
          direction="row"
          spacing={1}
          sx={{
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography>{item.quantity}</Typography>
          {/* <Typography>{newQty}</Typography> */}
          <IconButton
            aria-label="Edit"
            color="primary"
            size="small"
            onClick={handleEditClick}
          >
            <EditIcon fontSize="inherit" />
          </IconButton>
        </Stack>
      ) : (
        <Stack
          direction="row"
          spacing={1}
          sx={{
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <QuantityInput />
          <IconButton
            aria-label="Edit"
            color="error"
            size="small"
            onClick={handleCancelClick}
          >
            <ClearIcon fontSize="inherit" />
          </IconButton>
          <IconButton
            aria-label="Edit"
            color="success"
            size="small"
            onClick={handleUpdateClick}
          >
            <DoneOutlineIcon fontSize="inherit" />
          </IconButton>
          {/* <Stack
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
          >
            <IconButton
              aria-label="Edit"
              color="success"
              size="small"
              onClick={handleUpdateClick}
            >
              <DoneOutlineIcon fontSize="inherit" />
            </IconButton>
            <IconButton
              aria-label="Edit"
              color="error"
              size="small"
              onClick={handleCancelClick}
            >
              <ClearIcon fontSize="inherit" />
            </IconButton>
          </Stack> */}
        </Stack>
      )}
    </>
  );
};
